import React, { useEffect, useState, createContext } from 'react';
import Navhead from '../../Molecules/NavHead/Navhead';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import SideBar from '../../Molecules/SideBar/SideBar';
import styles from './GeneralBodyContainer.module.scss';
import WrappingContainer from '../WrappingContainer/WrappingContainer';
import { useNavigate } from 'react-router-dom';
import { pathConfig } from './PathConfig/PathConfig';
import PageAccessGate from '../../../routes/PageAccessGate';
export const PageTitleContext = createContext(null);
export const DetailsContext = createContext(null);

const GeneralBody = () => {
  const [pathName, setPathName] = useState('');
  const [isArrow, setIsArrow] = useState(false);
  const [details, setDetails] = useState(null);
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [moveRight, setMoveRight] = useState('');

  useEffect(() => {
    const pathURL = location.pathname.split('/')[2];
    const config = pathConfig[pathURL] || pathConfig.default;
    setPathName(config.title);
    setIsArrow(config.isArrow);

    // The expiry check that used to live here has moved to
    // `Molecules/Session/SessionGuard`. It was wrong in three ways: it ran only
    // when the route changed, so sitting on one screen past expiry warned
    // nobody; it removed `token` but left `tokenExpiry` and `userId`, so the app
    // looked signed-in to some screens and signed-out to others; and it
    // redirected to `/` with no message and no way back to the page — along
    // with anything unsaved on it.
  }, [location, id]);

  const handleNavigateBack = () => {
    if (!details) {
      navigate(-1);
    } else {
      setDetails(null);
    }
  };
  return (
    <div>
      <PageTitleContext.Provider
        value={{ setPathName: setPathName, setMoveRight: setMoveRight }}
      >
        <DetailsContext.Provider
          value={{ setDetails: setDetails, details: details }}
        >
          <div className={styles['generalBody']}>
            <SideBar />
            <div className={styles['generalBody-subcont']}>
              <Navhead
                moveRight={moveRight}
                title={pathName}
                isArrow={isArrow}
                details={details}
                handleNavigateBack={handleNavigateBack}
              />
              <WrappingContainer>
                {/* Every `/home` screen renders through this one Outlet, so
                    the gate around it covers all ~75 routes - including the
                    add/edit forms that a per-route wrapper would miss. */}
                <PageAccessGate>
                  <Outlet />
                </PageAccessGate>
              </WrappingContainer>
            </div>
          </div>
        </DetailsContext.Provider>
      </PageTitleContext.Provider>
    </div>
  );
};

export default GeneralBody;
